import {Component, EventEmitter, Inject, OnInit, Output} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

export interface GenericDialogData {
  title: string;
  text: string;
}

@Component({
  selector: 'app-generic-dialog',
  templateUrl: './generic-dialog.component.html',
  styleUrls: ['./generic-dialog.component.scss']
})
export class GenericDialogComponent implements OnInit {

  @Output()
  confirm: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(@Inject(MAT_DIALOG_DATA) public data: GenericDialogData) {}

  ngOnInit(): void {
  }

  onConfirm(confirm: boolean): void {
    this.confirm.emit(confirm);
  }

}
